import ModuleMixin from '@/Mixins/ModuleMixin'
import { EventBus } from '@/app'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.shipping',
            forms: {}
        }
    },

    methods: {
        status(resource, status) {
            return axios({
                method: 'post',
                url: route('api.shippings.status', resource),
                data: {status: status},
                params: {scopes: ['editable']}
            })
            .then(response => {
                if(response.data.success) {
                    this.$alert('Actualización exitosa', 'Listo!', 'success')

                    EventBus.$emit('root', 'shippings.statused', response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data,message, 'Error!', 'error')

                    return Promise.reject(response.data,message)
                }
            })
            .catch(error => {
                this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')

                return Promise.reject(Object.values(error.response.data.errors)[0][0])
            })
        },

        setTracking(resource, tracking) {
            return axios({
                method: 'post',
                url: route('api.shippings.set.tracking', resource),
                data: {tracking: tracking},
                params: {scopes: ['editable']}
            })
            .then(response => {
                if(response.data.success) {
                    this.$alert('Actualización exitosa', 'Listo!', 'success')

                    EventBus.$emit('root', 'shippings.tracked', response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data,message, 'Error!', 'error')

                    return Promise.reject(response.data,message)
                }
            })
            .catch(error => {
                this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')

                return Promise.reject(Object.values(error.response.data.errors)[0][0])
            })
        }
    },

    created() {
        this.$Util.formattedClassName['Modules\\Ecommerce\\Entities\\Shipping'] = 'Envío'
        this.$Util.tableNameByClassName['Modules\\Ecommerce\\Entities\\Shipping'] = 'shippings'
        this.$Util.classNameByTableName['shippings'] = 'Modules\\Ecommerce\\Entities\\Shipping'
    }
}